import { connect } from "react-redux";

import actions from "../../actions";
import SchedulePanelCosmoChiba from "../../components/summary/SchedulePanelCosmoChiba";

const mapStateToProps = (state) => {
  const { scheduleSelectedCells, loadingPanel } = state.summary;

  return {
    scheduleSelectedCells,
    loadingPanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createScheduleCosmoChiba: (params, callback, fallback) =>
      dispatch(actions.summary.createScheduleCosmoChiba(params, callback, fallback)),
    endSelectSchedule: (callback) => dispatch(actions.summary.endSelectSchedule(callback)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePanelCosmoChiba);
